import { render, staticRenderFns } from "./NoteButton.vue?vue&type=template&id=7d6c6dfc&"
import script from "./NoteButton.vue?vue&type=script&lang=js&"
export * from "./NoteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports